import ArticlePlaceholder from 'components/ui/article-placeholder';
import { useCallback, useContext, useEffect, useState, useRef } from 'react';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';

import { AuthContext } from 'context/AuthContext';

import { getFaqContent } from 'services/content.service';

type Props = {
  _id: string;
  title: string;
};

export default function FaqItem({ _id, title }: Props) {
  const [contentData, setContentData] = useState<string>();
  const [loading, setLoading] = useState<boolean>(false);
  const [opened, setOpened] = useState<boolean>(false);
  const { user } = useContext(AuthContext);
  const contentRef = useRef<HTMLDivElement>(null);

  const loadData = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getFaqContent(_id, user?.extra.rede);
      setContentData(data);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  }, [_id, user?.extra.rede]);

  useEffect(() => {
    if (opened && !loading && typeof contentData !== 'string') {
      loadData();
    }
  }, [contentData, loadData, loading, opened]);

  useEffect(() => {
    if (opened && contentRef.current) {
      contentRef.current.focus();
    }
  }, [opened, contentData]);

  return (
    <div className="space-y-3">
      <div
        onClick={() => setOpened(prevState => !prevState)}
        className="cursor-pointer hover:ring-1 ring-white border border-electric-blue bg-maastricht-blue rounded-xl p-3"
        onKeyDown={e => {
          if (e.key === 'Enter') setOpened(prevState => !prevState);
        }}
        tabIndex={0}
        role="button"
        aria-expanded={opened}
        aria-controls={`faq-content-${_id}`}
      >
        <div className="flex flex-row items-start justify-between">
          <h3 className="text-white font-bold leading-tight lg:text-xl">
            {title} <span className="opacity-0">{`botão de menu ${opened ? 'expandido' : 'recolhido'}`}</span>
          </h3>
          <button className="bg-none border-none" aria-hidden={true}>
            {!opened && <BiChevronDown size={28} />}
            {!!opened && <BiChevronUp size={28} />}
          </button>
        </div>
      </div>
      {!!opened &&
        (!!loading ? (
          <div className="mt-6">
            <ArticlePlaceholder />
          </div>
        ) : (
          <div
            id={`faq-content-${_id}`}
            className="p-3"
            dangerouslySetInnerHTML={{ __html: contentData || '' }}
            tabIndex={-1}
            ref={contentRef}
            aria-label={contentData}
          ></div>
        ))}
    </div>
  );
}
